import React, { useState, useEffect } from 'react';
import './styles/App.css';
import './styles/global.css';
import './styles/ShiftCalendar.css';
import './styles/StoresPage.css';
import './styles/StaffPage.css';
import './styles/RightSidebar.css'; // 右サイドバー用CSSをインポート

// 各ページコンポーネントのインポート
import ShiftsPage from './components/Shifts/ShiftsPage';
import AttendancePage from './components/Attendance/AttendancePage';
import StoresPage from './components/Stores/StoresPage';
import StaffPage from './components/Staff/StaffPage';
import RightSidebar from './components/common/RightSidebar'; // 右サイドバーコンポーネントをインポート

// ヘッダーコンポーネントの定義
const Header = ({ title, user, onMenuToggle }) => {
  return (
    <header className="app-header">
      <div className="header-left">
        <button 
          className="menu-toggle" 
          onClick={onMenuToggle}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '20px',
            marginRight: '20px',
            padding: '0',
            width: '30px'
          }}
        >
          <span style={{ backgroundColor: '#333', borderRadius: '3px', display: 'block', height: '3px', width: '100%' }}></span>
          <span style={{ backgroundColor: '#333', borderRadius: '3px', display: 'block', height: '3px', width: '100%' }}></span>
          <span style={{ backgroundColor: '#333', borderRadius: '3px', display: 'block', height: '3px', width: '100%' }}></span>
        </button>
        <h1 style={{ fontSize: '20px', fontWeight: '600', margin: '0' }}>{title}</h1>
      </div>
      
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ marginRight: '20px' }}>
          <span>こんにちは、{user?.name || 'ゲスト'}さん</span>
        </div>
      </div>
    </header>
  );
};

// サイドバーコンポーネントの定義
const Sidebar = ({ currentPage, onPageChange, isOpen, userData }) => {
  // 管理者権限を持つユーザーかどうかをチェック
  const isAdmin = userData?.role === '管理者';
  
  // メニュー項目のリスト
  const menuItems = [
    { id: 'dashboard', label: 'ダッシュボード', icon: 'dashicons-dashboard', requiresAdmin: false },
    { id: 'shifts', label: 'シフト管理', icon: 'dashicons-calendar-alt', requiresAdmin: false },
    { id: 'attendance', label: '勤怠管理', icon: 'dashicons-clock', requiresAdmin: false },
    { id: 'stores', label: '店舗管理', icon: 'dashicons-store', requiresAdmin: false },
    { id: 'staff', label: 'スタッフ管理', icon: 'dashicons-groups', requiresAdmin: false },
    { id: 'settings', label: '設定', icon: 'dashicons-admin-generic', requiresAdmin: true }
  ];
  
  const sidebarStyle = {
    background: '#343a40',
    color: '#adb5bd',
    height: 'calc(100vh - 60px)',
    position: 'fixed',
    top: '60px',
    transition: 'width 0.3s',
    width: isOpen ? '250px' : '60px',
    zIndex: 900
  };
  
  const navItemStyle = (isActive) => ({
    padding: '10px 15px',
    color: isActive ? '#fff' : '#adb5bd',
    backgroundColor: isActive ? '#007bff' : 'transparent',
    marginBottom: '5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
  });
  
  return (
    <aside style={sidebarStyle}>
      <nav style={{ padding: '15px 0' }}>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {menuItems.map(item => {
            // 管理者権限が必要な項目は、権限がない場合は表示しない
            if (item.requiresAdmin && !isAdmin) {
              return null;
            }
            
            return (
              <li key={item.id}>
                <div 
                  style={navItemStyle(currentPage === item.id)}
                  onClick={() => onPageChange(item.id)}
                >
                  <span className={`dashicons ${item.icon}`} style={{ marginRight: '10px' }}></span>
                  {isOpen && <span>{item.label}</span>}
                </div>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
};

// シンプルなダッシュボードコンポーネント
const Dashboard = ({ userData }) => (
  <div>
    <h2>ダッシュボード</h2>
    <p>NEKONOTE シフト管理システムへようこそ</p>
    <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
      <div style={{ flex: 1, padding: '15px', background: '#f9f9f9', border: '1px solid #ddd', borderRadius: '4px' }}>
        <h3>今日のシフト</h3>
        <p>シフト情報がここに表示されます</p>
      </div>
      <div style={{ flex: 1, padding: '15px', background: '#f9f9f9', border: '1px solid #ddd', borderRadius: '4px' }}>
        <h3>勤怠情報</h3>
        <p>勤怠情報がここに表示されます</p>
      </div>
    </div>
  </div>
);

// 設定ページのプレースホルダー
const SettingsPage = ({ settings, onSaveSettings }) => (
  <div>
    <h2>設定</h2>
    <p>システム設定の管理ができます</p>
    <div style={{ marginTop: '20px', padding: '15px', background: '#f9f9f9', border: '1px solid #ddd', borderRadius: '4px' }}>
      <h3>一般設定</h3>
      <div style={{ marginTop: '15px' }}>
        <div style={{ marginBottom: '10px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>システム名</label>
          <input type="text" style={{ padding: '8px', width: '100%', maxWidth: '300px' }} defaultValue="NEKONOTE" />
        </div>
        <div style={{ marginBottom: '10px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>営業時間</label>
          <input type="text" style={{ padding: '8px', width: '100%', maxWidth: '300px' }} defaultValue="9:00 - 22:00" />
        </div>
      </div>
    </div>
  </div>
);

// ローディングコンポーネント
const Loading = () => (
  <div style={{ textAlign: 'center', padding: '30px' }}>
    <div style={{ 
      display: 'inline-block',
      width: '40px',
      height: '40px',
      border: '4px solid rgba(0, 0, 0, 0.1)',
      borderRadius: '50%',
      borderTopColor: '#007bff',
      animation: 'spin 1s linear infinite'
    }}></div>
    <style>{`
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

// メインアプリケーションコンポーネント
const App = () => {
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [menuOpen, setMenuOpen] = useState(true);
  const [rightSidebarOpen, setRightSidebarOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [appSettings, setAppSettings] = useState({
    siteName: 'NEKONOTE',
    version: window.nekonoteData?.version || '1.0.0'
  });

  // アプリ初期化
  useEffect(() => {
    const initializeApp = async () => {
      try {
        // データページを取得
        const appElement = document.getElementById('nekonote-app');
        let page = 'dashboard';
        
        if (appElement) {
          page = appElement.getAttribute('data-page') || 'dashboard';
        }
        
        // ユーザーデータの取得（実際の実装ではAPIコールをする）
        const userId = window.nekonoteData?.user_id || 0;
        const isAdmin = window.nekonoteData?.is_admin === 1;
        
        // モックユーザーデータ
        const mockUser = {
          id: userId,
          name: 'ログインユーザー',
          role: isAdmin ? '管理者' : '一般ユーザー',
          avatar: null
        };
        
        setCurrentPage(page);
        setUserData(mockUser);
        
        // 読み込み完了
        setLoading(false);
      } catch (error) {
        console.error('アプリ初期化エラー:', error);
        setLoading(false);
      }
    };
    
    initializeApp();
  }, []);

  // ページ変更ハンドラー
  const handlePageChange = (page) => {
    setCurrentPage(page);
    
    // モバイル表示時はメニューを閉じる
    if (window.innerWidth < 768) {
      setMenuOpen(false);
    }
  };

  // サイドバー開閉の切り替え
  const toggleSidebar = () => {
    setMenuOpen(!menuOpen);
  };

  // 右サイドバー開閉の切り替え
  const toggleRightSidebar = () => {
    setRightSidebarOpen(!rightSidebarOpen);
  };

  // 現在のページに基づいてコンポーネントをレンダリング
  const renderPage = () => {
    switch (currentPage) {
      case 'shifts':
        return <ShiftsPage />;
      case 'attendance':
        return <AttendancePage />;
      case 'stores':
        return <StoresPage />;
      case 'staff':
        return <StaffPage />;
      case 'settings':
        return <SettingsPage settings={appSettings} onSaveSettings={setAppSettings} />;
      case 'dashboard':
      default:
        return <Dashboard userData={userData} />;
    }
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh'
      }}>
        <Loading />
      </div>
    );
  }

  const mainContentStyle = {
    flex: 1,
    marginLeft: menuOpen ? '250px' : '60px',
    padding: '20px',
    transition: 'margin-left 0.3s'
  };

  const contentWrapperStyle = { 
    backgroundColor: '#fff',
    borderRadius: '4px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
    padding: '20px'
  };

  const footerStyle = { 
    backgroundColor: '#fff',
    borderTop: '1px solid #e9ecef',
    marginTop: '20px',
    padding: '15px 20px',
    textAlign: 'center'
  };

  const footerTextStyle = { 
    color: '#6c757d', 
    fontSize: '12px', 
    margin: 0 
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header 
        title={appSettings.siteName}
        user={userData}
        onMenuToggle={toggleSidebar}
      />
      
      <div style={{ display: 'flex', flex: 1 }}>
        <Sidebar 
          currentPage={currentPage}
          onPageChange={handlePageChange}
          isOpen={menuOpen}
          userData={userData}
        />
        
        <main style={mainContentStyle}>
          <div style={contentWrapperStyle}>
            {renderPage()}
          </div>
        </main>
        
        {/* 右サイドバートグルボタン */}
        <button 
          className="toggle-right-sidebar"
          onClick={toggleRightSidebar}
          aria-label={rightSidebarOpen ? "サイドパネルを閉じる" : "サイドパネルを開く"}
        >
          {rightSidebarOpen ? "›" : "‹"}
        </button>
        
        {/* 右サイドバー */}
        <RightSidebar 
          isOpen={rightSidebarOpen} 
          onClose={() => setRightSidebarOpen(false)}
          currentPage={currentPage}
        />
      </div>
      
      <div style={footerStyle}>
        <p style={footerTextStyle}>
          © 2025 NEKONOTE シフト管理システム v{appSettings.version}
        </p>
      </div>
    </div>
  );
};

export default App;
